import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import useAuthHttp from "./useAuthHttp";
import { ITreasureSearchResponse } from "../components/TreasureBoundsSearchSelector";
import { treasurePurchaseQuote, treasureSaleUnitValue } from "../commons/treasure-quote";

/**
 * PU oficial do Tesouro na data: compra no aporte, venda no resgate.
 * É só sugestão — o usuário pode editar (negócio intradiário ou no secundário).
 */
export const useTreasureUnitValue = (
    treasureId: string | undefined,
    date: Date | undefined,
    side: "purchase" | "sale",
    onChange: (unitValue: number | null) => void
) => {
    const http = useAuthHttp();

    return useQuery({
        queryKey: ["treasureUnitValue", treasureId, date ? moment(date).format("YYYY-MM-DD") : null, side],
        enabled: !!treasureId && !!date,
        queryFn: async () => {
            const quote = await http.doGet<ITreasureSearchResponse>(`/treasure/br/fee/${treasureId}?date=${moment(date).format("YYYY-MM-DD")}`);
            const unitValue = side === "purchase"
                ? treasurePurchaseQuote(quote)?.unitValue ?? null
                : treasureSaleUnitValue(quote);

            onChange(unitValue);

            return unitValue;
        }
    });
};
